'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('multiplication', {
    url: '/multiplication',
    template: '<multiplication></multiplication>'
  });
}



// WEBPACK FOOTER //
// ./client/app/multiplication/multiplication.routes.js